exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".events-attractionscardsslider-component{padding-top:48px}@media (max-width:768px){.events-attractionscardsslider-component>*{padding-right:0!important;padding-left:0!important}}.events-attractionscardsslider-component .well{padding:24px;height:420px}@media (max-width:768px){.events-attractionscardsslider-component .well{padding-right:0!important;padding-left:0!important}}.events-attractionscardsslider-component__slider{margin-top:-48px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/events/attractionscardsslider.scss
// module id = 1017
// module chunks = 0